import { interviewURL } from "../../Redux/baseURL";

export class ApiService {
  constructor() {
    this.baseURL = interviewURL;
    this.token = localStorage.getItem("token");
  }

  async request(endpoint, config = {}) {
    const url = `${this.baseURL}${endpoint}`;

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error("API Request failed:", error);
      throw error;
    }
  }

  async generateQuestions(data) {
    return this.request("/interview/generateInterViewQuestions", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      },
      credentials: "include",
    });
  }

  async uploadAudio(audioFile, interviewData) {
    const formData = new FormData();
    formData.append("audio", audioFile);
    formData.append("interviewUniqueCode", interviewData.interviewUniqueCode);
    formData.append("interviewQuestionsId", interviewData.interviewQuestionsId);
    formData.append("questionId", interviewData.questionId);
    formData.append("language", interviewData.language);

    return this.request("/interview/uploadAudio", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
      credentials: "include",
      body: formData,
    });
  }

  async getQuestions() {
    return this.request(`/interview/getInterviewData`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      },
      credentials: "include",
    });
  }

  async getAnalytics(interviewQuestionsId, questionId, language) {
    return this.request(
      `/interview/getOneQuestionAnalytics/${interviewQuestionsId}/${questionId}/${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.token}`,
        },
        credentials: "include",
      }
    );
  }

  async getInterviewData() {
    return this.request("/interview/getInterviewData", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      },
      credentials: "include",
    });
  }

  async fetchOverallAnalytics(interviewId) {
    return this.request(
      `/interview/calculateOverallScore/${interviewId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );
  }
}
